// src/components/CookieBanner.jsx
import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";

const STORAGE_KEY = "ysw_cookie_consent"; // 'all' | 'essential'

const bannerStyle = {
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 9999,
  backgroundColor: "rgba(0, 0, 0, 0.9)",
  color: "#fff",
  padding: "12px 16px",
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "10px",
  fontFamily: "Montserrat, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
  fontSize: "0.85rem",
};

const textStyle = {
  flex: 1,
  minWidth: "220px",
  lineHeight: 1.4,
};

const buttonRowStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
  justifyContent: "flex-end",
};

const primaryButton = {
  padding: "6px 14px",
  borderRadius: "999px",
  border: "none",
  cursor: "pointer",
  fontWeight: 600,
  fontSize: "0.85rem",
  backgroundColor: "#4CAF50",
  color: "#fff",
};

const secondaryButton = {
  padding: "6px 14px",
  borderRadius: "999px",
  border: "1px solid #ffffff80",
  cursor: "pointer",
  fontWeight: 500,
  fontSize: "0.85rem",
  backgroundColor: "transparent",
  color: "#fff",
};

const linkStyle = {
  color: "#FFEB3B",
  textDecoration: "underline",
  fontWeight: 500,
};

const CookieBanner = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        setVisible(true);
      }
    } catch {
      // If localStorage unavailable, still show banner
      setVisible(true);
    }
  }, []);

  // Optionally hide on policy pages themselves
  useEffect(() => {
    if (
      location.pathname === "/privacy-policy" ||
      location.pathname === "/cookie-policy"
    ) {
      setVisible(false);
    }
  }, [location.pathname]);

  const acceptAll = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "all");
    } catch {}
    setVisible(false);
  };

  const acceptEssential = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "essential");
    } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={bannerStyle}>
      <div style={textStyle}>
        We use cookies to operate YourStoryWorld securely, remember your
        preferences, and understand how the site is used. By clicking{" "}
        <strong>“Accept all cookies”</strong>, you agree to the use of
        essential and optional cookies (for analytics and performance).
        You can choose <strong>“Accept only essential cookies”</strong> if
        you prefer not to allow optional cookies.
        {" "}
        See our{" "}
        <Link to="/cookie-policy" style={linkStyle}>
          Cookie Policy
        </Link>{" "}
        and{" "}
        <Link to="/privacy-policy" style={linkStyle}>
          Privacy Policy
        </Link>{" "}
        for more details.
      </div>

      <div style={buttonRowStyle}>
        <button type="button" style={secondaryButton} onClick={acceptEssential}>
          Accept only essential cookies
        </button>
        <button type="button" style={primaryButton} onClick={acceptAll}>
          Accept all cookies
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
